import * as React from 'react';
import { useSchedulerViewSlotsContext } from '../context';
import { COLLECTION_ACTION } from './useCollection';
/** @hidden */
export var useSchedulerSlot = function (props, ref) {
    var _ref = props._ref;
    var slot = React.useRef(null);
    var element = React.useRef(null);
    var _a = useSchedulerViewSlotsContext(), dispatchSlots = _a[1];
    React.useImperativeHandle(slot, function () { return ({ element: element.current, props: props }); });
    React.useImperativeHandle(ref, function () { return slot.current; });
    React.useImperativeHandle(_ref, function () { return slot.current; });
    React.useEffect(function () {
        var target = slot.current;
        if (target) {
            dispatchSlots({
                type: COLLECTION_ACTION.add,
                item: target
            });
            return function () {
                dispatchSlots({
                    type: COLLECTION_ACTION.remove,
                    item: target
                });
            };
        }
    });
    return {
        slot: slot,
        element: element
    };
};
//# sourceMappingURL=useSchedulerSlot.js.map